import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'src/app/material.module';
import { IframeDialogComponent } from './iframe-dialog.component';
import { IconModule } from 'src/app/shared/components/icon/icon.module';
import { ButtonsModule } from 'src/app/shared/components/buttons/buttons.module';

@NgModule({
  declarations: [IframeDialogComponent],
  imports: [CommonModule, MaterialModule, IconModule, ButtonsModule],
  exports: [IframeDialogComponent],
  entryComponents: [IframeDialogComponent],
})
export class IframeDialogModule {}
